import AlertIcon from "@assets/icons/alert-icon.svg";
import EmailSyncIcon from "@assets/icons/email-sync-icon.svg";

import { ERROR_MESSAGES } from "@config/messages";
import { ImageSection } from "@components/Sections/ImageSection";
import { Paragraph } from "@ui/Content";
import { Button } from "@ui/Button";
import { H3 } from "@ui/Headings";

interface Props {
  onTryAgain: VoidFunction;
}

export default function IssueScreen({ onTryAgain }: Props) {
  return (
    <>
      <ImageSection
        mainIcon={<EmailSyncIcon className="w-full h-full z-20 object-contain"/>}
        overlayIcon={<AlertIcon className="text-yellow-500" />}
        overlayIconBackground="bg-yellow-100"
      />

      <H3 className="text-yellow-600 dark:text-yellow-600 my-[19px]">Connection Issue</H3>

      <div className="flex flex-col gap-4 pt-[32px] pb-6 px-4 border-t dark:border-gray-700">
        <Paragraph>{ERROR_MESSAGES.SYNC_EMAIL}</Paragraph>
      </div>

      <Button className="min-w-[270px]" buttonType={"PRIMARY"} onClick={onTryAgain}>
        Try Again
      </Button>
    </>
  );
}
